export var PullingSecuredContent;
(function (PullingSecuredContent) {
    PullingSecuredContent["StandBy"] = "stand-by";
    PullingSecuredContent["Secured"] = "secured";
    PullingSecuredContent["PullPush"] = "pull / push";
    PullingSecuredContent["Push"] = "push";
    PullingSecuredContent["LetGo"] = "let-go";
    PullingSecuredContent["Released"] = "released";
})(PullingSecuredContent || (PullingSecuredContent = {}));
//# sourceMappingURL=PullingSecuredContent.js.map